import { Injectable } from '@angular/core';
import { OrganisationAzureLoginApiService } from '@get/store/api-services';
import { AppState } from '@get/store/configs/reducers';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { GeneratedOrganisationAzureLoginEffects } from './organisation-azure-login-generated.effects';

@Injectable()
export class OrganisationAzureLoginEffects extends GeneratedOrganisationAzureLoginEffects {
  constructor(
    actions$: Actions,
    organisationAzureLoginApiService: OrganisationAzureLoginApiService,
    store$: Store<AppState>
  ) {
    super(actions$, organisationAzureLoginApiService, store$);
  }
}
